/**
 * @generated SignedSource<<0f64d64f4645d66d06ffd2576a835177>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineOccasionTodoIssueHighlightedQuery$variables = Record<PropertyKey, never>;
export type RoutineOccasionTodoIssueHighlightedQuery$data = {
  readonly store: {
    readonly activeIssueId: string | null;
  };
};
export type RoutineOccasionTodoIssueHighlightedQuery = {
  response: RoutineOccasionTodoIssueHighlightedQuery$data;
  variables: RoutineOccasionTodoIssueHighlightedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeIssueId",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineOccasionTodoIssueHighlightedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RoutineOccasionTodoIssueHighlightedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8eab233e60b43f9af8f57a8d829b6de6",
    "id": null,
    "metadata": {},
    "name": "RoutineOccasionTodoIssueHighlightedQuery",
    "operationKind": "query",
    "text": "query RoutineOccasionTodoIssueHighlightedQuery {\n  store {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc880552120cb924acf363f53e722578";

export default node;
